import Splide from '@splidejs/splide'

export class Slider {
    constructor (element) {
        this.element = element
        // remove empty slides from user template
        document.querySelectorAll('[data-role="slider-item"]').forEach(item => {
            if (item.firstElementChild.childNodes.length === 0) item.remove()
        })
        this.initSlider()
    }

    initSlider () {
        new Splide(this.element, {
            type: 'loop',
            autoplay: true,
            pagination: false,
            keyboard: true,
        }).mount()
    }
}



// WEBPACK FOOTER //
// ./src/Frontend/Themes/Custom/src/Js/Modules/Slider.js